module.exports = __webpack_public_path__ + "img/share-content_zh-HK.b379b6ae.png";